import { t } from "i18next";
import React from "react";
import { useUploadStore } from "../../stores/uploadFirmwareStore";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UploadedFirmwareInfo from "./firmwareInfo";

const UploadedFileInfo: React.FC = () => {
  const {
    firmwareInfo,
    setFirmwareInfo,
    firmwareEcu2Info,
    setSelectedFile,
    setFileUploaded,
  } = useUploadStore();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <p className="text-xl">{t("File info")}</p>
      <div className="">
        <div className="mt-4 md:p-1 xl:p-5 border rounded-xl border-tableline">
          <UploadedFirmwareInfo firmwareInfo={firmwareInfo} />

          <button
            className="flex items-center justify-center border-primary border border-solid rounded-lg px-3 
              mt-5
              cursor-pointer hover:bg-primary h-11 w-full transition duration-300 ease-in-out"
            onClick={() => {
              setFirmwareInfo(null);
              setSelectedFile(null);
              setFileUploaded(false);
            }}
          >
            {t("Upload new file")}
          </button>
        </div>
      </div>
      {firmwareEcu2Info && (
        <>
          <p className="text-xl">{t("File info")} ECU2</p>
          <div className="mt-4 md:p-1 xl:p-5 border rounded-xl border-tableline">
            <UploadedFirmwareInfo firmwareInfo={firmwareEcu2Info} />
          </div>
        </>
      )}
    </>
  );
};

export default UploadedFileInfo;
